

{
  "familyId": "TAA-SOORT-WW",
  "questions": [
    {
      "id": "TAA-SOORT-WW-001",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "text_highlight",
      "question": "Markeer het werkwoord in de zin.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De kinderen spelen buiten in de tuin.",
        "correctHighlights": ["spelen"],
        "highlightUnit": "word"
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Wat is een werkwoord?", "content": "Een werkwoord beschrijft wat iemand doet, voelt of is. Vraag: 'Wat doen de kinderen?' Het antwoord is het werkwoord.", "icon": "book" }, "showWhen": "wrong" }
      ],
      "conceptId": "werkwoord_herkennen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het werkwoord is 'spelen' — het beschrijft wat de kinderen doen. Vraag altijd: 'Wat doet/doen ...?' Het antwoord is het werkwoord.",
        "solutionSteps": [
          "Stel de vraag: 'Wat doen de kinderen?'",
          "Het antwoord is 'spelen'",
          "Dus 'spelen' is het werkwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-002",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "text_highlight",
      "question": "Markeer het werkwoord in de zin.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Mijn moeder bakt elke zondag een taart.",
        "correctHighlights": ["bakt"],
        "highlightUnit": "word"
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Werkwoord vinden", "content": "Vraag: 'Wat doet mijn moeder?' → bakt. Dat is het werkwoord.", "icon": "book" }, "showWhen": "wrong" }
      ],
      "conceptId": "werkwoord_handeling",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Bakt' is het werkwoord — het beschrijft de handeling (bakken). Vraag: 'Wat doet mijn moeder?' → bakt.",
        "solutionSteps": [
          "Stel de vraag: 'Wat doet mijn moeder?'",
          "Het antwoord is 'bakt'",
          "Dus 'bakt' is het werkwoord (handeling: bakken)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-003",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "text_highlight",
      "question": "Markeer ALLE werkwoorden in de zin. Let op: er zijn er meer dan één!",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De hond rent snel en blaft luid.",
        "correctHighlights": ["rent", "blaft"],
        "highlightUnit": "word"
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Meerdere werkwoorden", "content": "Een zin kan meerdere werkwoorden hebben. Zoek alle woorden die beschrijven wat iemand doet: rent (wat doet de hond?) en blaft (wat doet de hond nog meer?).", "icon": "book" }, "showWhen": "wrong" }
      ],
      "conceptId": "werkwoord_meerdere",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er zijn twee werkwoorden: 'rent' en 'blaft'. Beide beschrijven wat de hond doet. 'Snel' en 'luid' zijn bijwoorden — ze beschrijven hoe de hond rent en blaft.",
        "solutionSteps": [
          "Vraag: 'Wat doet de hond?' → rent",
          "Vraag: 'Wat doet de hond nog meer?' → blaft",
          "'Snel' en 'luid' beschrijven hoe → bijwoorden, geen werkwoorden"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-004",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "categorize",
      "question": "Sorteer de woorden: welke zijn werkwoorden en welke niet?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Werkwoord", "Geen werkwoord"],
        "items": [
          { "text": "rennen", "correctCategory": 0 },
          { "text": "snel", "correctCategory": 1 },
          { "text": "slapen", "correctCategory": 0 },
          { "text": "tafel", "correctCategory": 1 },
          { "text": "lachen", "correctCategory": 0 },
          { "text": "groot", "correctCategory": 1 }
        ]
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "Werkwoord of niet?", "content": "Werkwoorden beschrijven een handeling, toestand of gevoel: rennen, slapen, lachen. Bijvoeglijke naamwoorden beschrijven een eigenschap: snel, groot. Zelfstandige naamwoorden zijn dingen: tafel.", "icon": "book" }, "showWhen": "wrong" }
      ],
      "conceptId": "werkwoord_onderscheid",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Werkwoorden: rennen (handeling), slapen (toestand), lachen (handeling). Geen werkwoorden: snel (bijvoeglijk naamwoord), tafel (zelfstandig naamwoord), groot (bijvoeglijk naamwoord).",
        "solutionSteps": [
          "Rennen → kun je het doen? Ja → werkwoord ✓",
          "Snel → beschrijft het een eigenschap? Ja → geen werkwoord",
          "Slapen → kun je het doen? Ja → werkwoord ✓",
          "Tafel → is het een ding? Ja → geen werkwoord",
          "Lachen → kun je het doen? Ja → werkwoord ✓",
          "Groot → beschrijft het een eigenschap? Ja → geen werkwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-005",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "text_highlight",
      "question": "Markeer het werkwoord in de zin. Pas op: het is niet altijd een doe-woord!",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Het kleine meisje is heel gelukkig.",
        "correctHighlights": ["is"],
        "highlightUnit": "word"
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "data": { "title": "'Zijn' als werkwoord", "content": "'Zijn' (ben/bent/is/zijn) is ook een werkwoord! Het beschrijft een toestand. 'Is' is het werkwoord in deze zin.", "icon": "book" }, "showWhen": "wrong" }
      ],
      "conceptId": "werkwoord_zijn_toestand",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Is' is het werkwoord. 'Zijn' (ben/bent/is/zijn) is een werkwoord dat een toestand beschrijft. 'Kleine' en 'gelukkig' zijn bijvoeglijke naamwoorden, 'meisje' is een zelfstandig naamwoord.",
        "solutionSteps": [
          "Zoek het werkwoord: wat doet of is het meisje?",
          "Het meisje 'is' gelukkig → 'is' beschrijft de toestand",
          "'Is' is een vorm van 'zijn' → werkwoord",
          "'Kleine' en 'gelukkig' beschrijven eigenschappen → bijvoeglijke naamwoorden"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-006",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste woordsoort.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "rennen", "right": "werkwoord" },
          { "left": "tafel", "right": "zelfstandig naamwoord" },
          { "left": "snel", "right": "bijvoeglijk naamwoord" },
          { "left": "de", "right": "lidwoord" }
        ]
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Woordsoorten herkennen", "content": "Werkwoord = doe-woord (rennen, lopen). Zelfstandig naamwoord = persoon/dier/ding (tafel, hond). Bijvoeglijk naamwoord = eigenschap (snel, groot). Lidwoord = de, het, een.", "icon": "book" } }
      ],
      "conceptId": "werkwoord_matching_woordsoorten",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Rennen = werkwoord (je kunt het doen). Tafel = zelfstandig naamwoord (een ding). Snel = bijvoeglijk naamwoord (een eigenschap). De = lidwoord (staat voor een zelfstandig naamwoord).",
        "solutionSteps": [
          "Rennen → kun je het doen? Ja → werkwoord",
          "Tafel → is het een ding/persoon? Ja → zelfstandig naamwoord",
          "Snel → beschrijft het een eigenschap? Ja → bijvoeglijk naamwoord",
          "De → staat het voor een znw? Ja → lidwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-007",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het juiste type.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "lopen", "right": "handeling" },
          { "left": "slapen", "right": "toestand" },
          { "left": "houden van", "right": "gevoel" },
          { "left": "zijn", "right": "koppelwerkwoord" }
        ]
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Soorten werkwoorden", "content": "Handelingswerkwoord = iets doen (lopen, eten). Toestandswerkwoord = een toestand (slapen, liggen). Gevoelswerkwoord = een gevoel (houden van, haten). Koppelwerkwoord = zijn, worden, blijven.", "icon": "book" } }
      ],
      "conceptId": "werkwoord_matching_types",
      "variantIndex": 7,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Lopen = handeling (je doet iets). Slapen = toestand (je bent ergens). Houden van = gevoel (je voelt iets). Zijn = koppelwerkwoord (verbindt onderwerp met eigenschap).",
        "solutionSteps": [
          "Lopen → doe je iets? Ja → handeling",
          "Slapen → is het een toestand? Ja → toestand",
          "Houden van → is het een gevoel? Ja → gevoel",
          "Zijn → verbindt het onderwerp met eigenschap? Ja → koppelwerkwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-008",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "matching",
      "question": "Koppel elk woord uit de zin aan de juiste woordsoort. Zin: 'De grote hond blaft luid.'",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "blaft", "right": "werkwoord" },
          { "left": "hond", "right": "zelfstandig naamwoord" },
          { "left": "grote", "right": "bijvoeglijk naamwoord" },
          { "left": "luid", "right": "bijwoord" }
        ]
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Woordsoorten in een zin", "content": "Werkwoord = wat doet de hond? → blaft. Zelfstandig naamwoord = wie/wat? → hond. Bijvoeglijk naamwoord = hoe is de hond? → grote. Bijwoord = hoe blaft hij? → luid.", "icon": "book" } }
      ],
      "conceptId": "werkwoord_matching_zin",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Blaft = werkwoord (wat doet de hond?). Hond = zelfstandig naamwoord (wie/wat?). Grote = bijvoeglijk naamwoord (hoe is de hond?). Luid = bijwoord (hoe blaft hij?).",
        "solutionSteps": [
          "Blaft → wat doet de hond? → werkwoord",
          "Hond → wie/wat? → zelfstandig naamwoord",
          "Grote → hoe is de hond? → bijvoeglijk naamwoord",
          "Luid → hoe blaft hij? → bijwoord"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-009",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "categorize",
      "question": "Sorteer de woorden in de juiste categorie.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Werkwoord", "Zelfstandig naamwoord", "Bijvoeglijk naamwoord"],
        "items": [
          { "text": "lopen", "correctCategory": 0 },
          { "text": "hond", "correctCategory": 1 },
          { "text": "mooi", "correctCategory": 2 },
          { "text": "spelen", "correctCategory": 0 },
          { "text": "tafel", "correctCategory": 1 },
          { "text": "groot", "correctCategory": 2 }
        ]
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "woordsoort_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Werkwoorden geven een handeling aan (lopen, spelen). Zelfstandige naamwoorden zijn mensen, dieren of dingen (hond, tafel). Bijvoeglijke naamwoorden zeggen iets over een zelfstandig naamwoord (mooi, groot).",
        "solutionSteps": [
          "Werkwoorden: wat je kunt doen (lopen, spelen)",
          "Zelfstandige naamwoorden: waar je 'de', 'het' of 'een' voor kunt zetten (hond, tafel)",
          "Bijvoeglijke naamwoorden: hoe iets is (mooi, groot)"
        ]
      }
    },
    {
      "id": "TAA-SOORT-WW-010",
      "familyId": "TAA-SOORT-WW",
      "module": "Taalbegrip",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_werkwoord",
      "questionType": "categorize",
      "question": "Sorteer de woorden in de juiste categorie.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Werkwoord", "Zelfstandig naamwoord", "Bijvoeglijk naamwoord"],
        "items": [
          { "text": "fietsen", "correctCategory": 0 },
          { "text": "boom", "correctCategory": 1 },
          { "text": "snel", "correctCategory": 2 },
          { "text": "lezen", "correctCategory": 0 },
          { "text": "boek", "correctCategory": 1 },
          { "text": "dik", "correctCategory": 2 }
        ]
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "woordsoort_categorize_2",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Werkwoorden geven een handeling aan (fietsen, lezen). Zelfstandige naamwoorden zijn mensen, dieren of dingen (boom, boek). Bijvoeglijke naamwoorden zeggen iets over een zelfstandig naamwoord (snel, dik).",
        "solutionSteps": [
          "Werkwoorden: wat je kunt doen (fietsen, lezen)",
          "Zelfstandige naamwoorden: waar je 'de', 'het' of 'een' voor kunt zetten (boom, boek)",
          "Bijvoeglijke naamwoorden: hoe iets is (snel, dik)"
        ]
      }
    }
  ]
}

